import React from 'react';
import { Brain } from "lucide-react";

const DisclaimerModal = ({ content, onAccept }) => (
  <div className="fixed inset-0 z-[1000] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-in fade-in duration-200">
    <div className="bg-white w-full max-w-lg rounded-2xl shadow-2xl overflow-hidden flex flex-col max-h-[85vh]">
      <div className="p-5 border-b border-slate-100 bg-orange-50/50 flex items-center gap-3">
        <div className="p-2 bg-orange-100 rounded-lg text-orange-600">
          <Brain size={20} />
        </div>
        <h3 className="font-black text-lg text-slate-800">使用免責聲明</h3>
      </div>
      <div className="p-6 overflow-y-auto text-sm leading-relaxed text-slate-600 whitespace-pre-wrap">
        {content}
      </div>
      <div className="p-5 border-t border-slate-100 bg-slate-50 flex justify-end">
        <button
          onClick={onAccept}
          className="px-6 py-2.5 bg-orange-500 hover:bg-orange-600 text-white font-bold rounded-xl transition-all shadow-md active:scale-95"
        >
          我已閱讀並同意
        </button>
      </div>
    </div>
  </div>
);

export default DisclaimerModal;
